// extracted by mini-css-extract-plugin
module.exports = {"actions":"_8379","icon":"_2240"};